import ApprovalForecast from "@/components/sales-forecast/approval-forecast/ApprovalForecast.vue";
// import AreaAdd from "@/components/master/area/AreaAdd.vue";
// import AreaDetail from "@/components/master/area/AreaDetail.vue";
// import AreaEdit from "@/components/master/area/AreaEdit.vue";
// import AreaUpload from "@/components/master/area/AreaUpload.vue";

let routesApprovalForecast = [
    
    {
        path: '',
        meta: {
          title: "Sales System",
        },
        name: "ApprovalForecastIndex",
        component: ApprovalForecast
      },
      // {
      //   path: 'add',
      //   meta: {
      //     title: "Sales System",
      //   },
      //   name: "AreaAdd",
      //   component: AreaAdd
      // },
    
      // {
      //   path: 'edit/:id',
      //   meta: {
      //     title: "Sales System",
      //   },
      //   name: "AreaEdit",
      //   component: AreaEdit
      // },
    
      // {
      //   path: 'detail/:id',
      //   meta: {
      //     title: "Sales System",
      //   },
      //   name: "AreaDetail",
      //   component: AreaDetail
      // },
    
      // {
      //   path: 'upload',
      //   meta: {
      //     title: "Sales System",
      //   },
      //   name: "AreaUpload",
      //   component: AreaUpload
      // },
  ]
  
  export default routesApprovalForecast
  